import { Component, computed, EventEmitter, input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  BookingAvailabilityOption,
  ConversationMessage,
} from '../../../../../../../core/src/lib/interface/conversation.interface';
import { MatIconModule } from '@angular/material/icon';

import { MatButton } from '@angular/material/button';
import { BOOKING_AVAILABILITY_KEY } from '../../../../../../../core/src/lib/conversation.constants';
import { ConversationPipesModule } from '../../../../../../../pipes/src/pipes.module';

@Component({
  selector: 'inbox-booking-availability-component',
  templateUrl: './booking-availability.component.html',
  styleUrls: ['./booking-availability.component.scss'],
  imports: [MatIconModule, MatButton, ConversationPipesModule],
})
export class BookingAvailabilityComponent implements OnChanges {
  inputMessage = input.required<ConversationMessage>();
  messageMetadata = computed(() => this.inputMessage()?.metadata ?? []);

  @Output() preferredBooking = new EventEmitter<BookingAvailabilityOption>();
  bookingAvailabilities: BookingAvailabilityOption[] = [];

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.inputMessage) {
      await this.parseMetadata();
    }
  }

  private async parseMetadata() {
    if (!this.messageMetadata()) return;

    for (const m of this.messageMetadata()) {
      if (m.key !== BOOKING_AVAILABILITY_KEY) continue;

      if (m.value && m.value.length > 0) {
        this.bookingAvailabilities = JSON.parse(m.value) as BookingAvailabilityOption[];
      }

      break;
    }
  }

  async setPreferredBooking(booking: BookingAvailabilityOption) {
    this.preferredBooking.emit(booking);
  }
}
